<template>
  <v-row>
    <v-col sm="12" class="pa-0">
      <v-tabs v-model="currentTab">
        <v-tab>Добавление индекса рода</v-tab>
        <v-tab>Редактирование индекса рода</v-tab>
      </v-tabs>

      <v-card tile class="pa-4 mt-4">
        <v-tabs-items v-model="currentTab">
          <v-tab-item>
            <GenusIndexCreateComponent />
          </v-tab-item>
          <v-tab-item>
            <GenusIndexEditComponent />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import GenusIndexCreateComponent from "@/components/GenusIndexManageComponents/GenusIndexCreateComponent.vue"
import GenusIndexEditComponent from "@/components/GenusIndexManageComponents/GenusIndexEditComponent.vue";

export default {
  name: 'IndexAndGenusManageComponent',

  components: {GenusIndexCreateComponent, GenusIndexEditComponent},

  data() {
    return {
      currentTab: null,
    };
  },
};
</script>

<style scoped>

</style>
